module.exports = __webpack_public_path__ + "img/mvg-logo.218d568a.png";